class ScheduledProduct extends HTMLElement {
  constructor() {
    super();

    // 1. Get and validate the scheduled time (in seconds, convert to milliseconds)
    const scheduledTimeSeconds = parseInt(this.dataset.scheduledTime);
    if (isNaN(scheduledTimeSeconds)) {
      console.error('ScheduledProduct Error: data-scheduled-time is missing or invalid.');
      return;
    }
    this.scheduledTimeMs = scheduledTimeSeconds * 1000;

    // 2. Select the containers based on data attributes
    this.messageContainer = this.querySelector('[data-product-message]');
    this.buyButtonContainer = this.querySelector('[data-product-buy-buttons]');

    // 3. Determine if the time has already passed on the client's clock
    const timePassedOnLoad = this.scheduledTimeMs <= Date.now();
    
    if (timePassedOnLoad) {
        // If Liquid rendered the hidden state but client clock shows time passed,
        // force the transition immediately upon load to show the buttons.
        this.forceTransition();
        console.log('ScheduledProduct: Time passed on load. State corrected and buttons visible.');
    } else {
        // Time is in the future, start the timer.
        console.log(`ScheduledProduct: Waiting for product launch at ${new Date(this.scheduledTimeMs).toLocaleString()}.`);
        this.timer = setInterval(() => this.checkAvailability(), 1000);
    }
  }

  // This function performs the actual visibility switch (message hide, button show)
  forceTransition() {
    // Hide the message container (e.g., "Available Soon")
    if (this.messageContainer) {
      this.messageContainer.classList.add('hidden');
      this.messageContainer.setAttribute('aria-hidden', 'true');
    }

    // Show the buy button container
    if (this.buyButtonContainer) {
      this.buyButtonContainer.classList.remove('hidden');
      this.buyButtonContainer.setAttribute('aria-hidden', 'false');
      
      // Dispatch an event to force any dependent theme components (like the main product-form) to initialize
      const productForm = this.buyButtonContainer.querySelector('product-form, form');
      if (productForm) {
          productForm.dispatchEvent(new Event('dom:ready', { bubbles: true }));
      }
    }
  }

  checkAvailability() {
    const currentTimeMs = Date.now();
    
    if (currentTimeMs >= this.scheduledTimeMs) {
      console.log('ScheduledProduct: Launch time reached! Showing buy buttons.');
      this.forceTransition(); 
      // Stop checking the time
      clearInterval(this.timer);
    }
  }

  disconnectedCallback() {
    // Clean up the interval when the element is removed from the DOM
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}

// Define the custom element
customElements.define('scheduled-product', ScheduledProduct);